'use client';

import { c as _c } from "react/compiler-runtime";
import { motion } from 'framer-motion';
import { memo } from 'react';
import { Image } from '@/components/client';
import { WELLO_IMAGE_PREFIX_URL } from '@/constants';
import { useInviteEventPeriodValue } from '../_hooks/useInviteEventPeriodValue';
const MARKET_IMAGE_URL = `${WELLO_IMAGE_PREFIX_URL}/static/event/home-love/market`;
const PRODUCT_LIST_IMAGE = 'prod-list.png';
const ProductSlider = memo(function ProductSlider() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="absolute left-1/2 top-1/2 h-130 w-[750px] -translate-x-1/2 translate-y-[calc(-50%+20px)] overflow-hidden"><motion.div className="flex h-full" initial={{
        x: "0%"
      }} animate={{
        x: "-50%"
      }} transition={{
        repeat: Infinity,
        repeatType: "loop",
        duration: 20,
        ease: "linear"
      }}>{[0, 1].map(_temp)}</motion.div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
});
export const RewardSection = () => {
  const $ = _c(18);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      ssrFallbackValue: false
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const isSecondEvent = useInviteEventPeriodValue(false, true, t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="rounded-xxlarge bg-[#fff1dc] px-20 py-8"><p className="text-center font-700 text-[#c21511] typo-body1">12월 친구 초대 추가 혜택</p></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className="font-800 text-Gray-white typo-h2">FRIENDS</p>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="text-center">{t2}<p className="font-800 typo-h2"><span className="text-[#e4302c]">MAX</span><span className="text-Gray-white"> REWARD</span></p></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <br />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex flex-col items-center gap-20">{t1}{t3}<p className="text-center font-600 text-Gray-white typo-body2">초대한 친구들이{t4}기부에 많이 참여할수록<br />BIG 경품 당첨 확률 UP!</p></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="relative w-full"><div className="relative aspect-[375/328] w-full"><Image src={`${MARKET_IMAGE_URL}/price1-box-black.png`} alt={"\uC120\uBB3C \uC0C1\uC790"} fill={true} sizes="(max-width: 1279px) 100vw, 375px" className="object-contain" /></div><ProductSlider /></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="flex items-center gap-8"><div className="rounded-xxlarge bg-[#f6e0cf] px-12 py-4"><p className="font-700 text-[#c21511] typo-body1">1등</p></div><p className="font-700 text-[#f6e0cf] typo-h5">지역별 특산품 20종</p><p className="font-700 text-[#f6e0cf] typo-body3">(1명)</p></div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="flex w-full flex-col items-center">{t6}{t7}<p className="mt-8 text-center font-400 text-Gray-white/60 typo-caption1">*위 이미지는 예시이며,<br />20개 지역별로 원하는 답례품 1종씩 선택하실 수 있습니다.</p></div>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="relative aspect-[327/149] w-full overflow-hidden rounded-xxsmall"><Image src={`${MARKET_IMAGE_URL}/price2.png`} alt={"\uC544\uC6C3\uBC31 10\uB9CC\uC6D0 \uC2DD\uC0AC\uAD8C"} fill={true} sizes="(max-width: 1279px) 100vw, 327px" className="object-cover" /></div>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="flex w-full flex-col items-center gap-16 pt-4">{t9}<div className="flex items-center gap-8"><div className="rounded-xxlarge bg-[#f6e0cf] px-12 py-4"><p className="font-700 text-[#c21511] typo-body1">2등</p></div><p className="font-700 text-[#f6e0cf] typo-h5">아웃백 10만원 식사권</p><p className="font-700 text-[#f6e0cf] typo-body3">(1명)</p></div></div>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="relative aspect-[327/144] w-full overflow-hidden rounded-xxsmall"><Image src={`${MARKET_IMAGE_URL}/price3.png`} alt={"\uC2E0\uC138\uACC4 \uC0C1\uD488\uAD8C 5\uB9CC\uC6D0\uAD8C"} fill={true} sizes="(max-width: 1279px) 100vw, 327px" className="object-cover" /></div>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="flex w-full flex-col items-center gap-16 pt-4">{t11}<div className="flex items-center gap-8"><div className="rounded-xxlarge bg-[#f6e0cf] px-12 py-4"><p className="font-700 text-[#c21511] typo-body1">3등</p></div><p className="font-700 text-[#f6e0cf] typo-h5">신세계 상품권 5만원권</p><p className="font-700 text-[#f6e0cf] typo-body3">(1명)</p></div></div>;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  const t13 = isSecondEvent ? "\uACBD\uD488 \uCD94\uCCA8\uC740 \uC774\uBCA4\uD2B8 \uAE30\uAC04\uC774 \uC885\uB8CC\uB41C \uD6C4, 1\uC6D4 \uB0B4\uC5D0 \uC9C4\uD589\uB429\uB2C8\uB2E4." : "\uACBD\uD488 \uCD94\uCCA8\uC740 \uC774\uBCA4\uD2B8 \uAE30\uAC04\uC774 \uC885\uB8CC\uB41C \uD6C4, 12\uC6D4 \uB0B4\uC5D0 \uC9C4\uD589\uB429\uB2C8\uB2E4.";
  let t14;
  if ($[13] !== t13) {
    t14 = <li className="ml-20 list-disc">{t13}</li>;
    $[13] = t13;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <li className="ml-20 list-disc">{"\uB2F9\uCCA8\uC790\uC5D0 \uD55C\uD574 \uAC1C\uBCC4\uC801\uC73C\uB85C \uC5F0\uB77D\uB4DC\uB9B4 \uC608\uC815\uC774\uBA70, \uC0C1\uC138 \uB0B4\uC6A9\uC740 \uCD94\uD6C4 '\uB9C8\uC774\uD398\uC774\uC9C0 > \uACF5\uC9C0\uC0AC\uD56D'\uC744 \uD655\uC778\uD574\uC8FC\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4."}</li>;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  if ($[16] !== t14) {
    t16 = <section className="w-full overflow-hidden bg-Gray-black"><div className="mx-auto flex max-w-[375px] flex-col gap-36 px-20 py-60">{t5}{t8}{t10}{t12}<ul className="flex flex-col gap-4 font-400 text-Gray-white/70 typo-caption1">{t14}{t15}</ul></div></section>;
    $[16] = t14;
    $[17] = t16;
  } else {
    t16 = $[17];
  }
  return t16;
};
function _temp(index) {
  return <div key={index} className="relative aspect-[1920/89] h-130 shrink-0"><Image src={`${MARKET_IMAGE_URL}/${PRODUCT_LIST_IMAGE}`} alt={"\uD2B9\uC0B0\uD488 \uBAA9\uB85D"} fill={true} sizes="(max-width: 1279px) 200vw, 750px" className="object-contain" unoptimized={true} /></div>;
}